import * as React from "react";
import type { SVGProps } from "react";
const SvgPersonSwimming = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.17 11.81c.71 0 1.42-.27 1.96-.81l.32-.32a2.79 2.79 0 0 0 0-3.93 2.79 2.79 0 0 0-3.93 0l-.32.32a2.79 2.79 0 0 0 0 3.93c.54.54 1.25.81 1.96.81zm-.55-3.32.32-.32a.78.78 0 0 1 .55-.23c.2 0 .4.08.55.23.3.3.3.79 0 1.1l-.32.32c-.3.3-.8.3-1.1 0s-.3-.79 0-1.1M6.45 11.9l3.41-1.7 2.28 1.96-.94 1.25c-.33.44-.24 1.07.2 1.4.18.13.39.2.6.2.3 0 .6-.14.8-.4l1.5-2a.997.997 0 0 0-.15-1.36l-3.5-3c-.3-.26-.74-.31-1.1-.14l-4 2c-.49.25-.69.85-.45 1.34s.85.69 1.34.45zm14.1 3.96a1 1 0 0 1 1.34.45h.02c.25.49.04 1.09-.45 1.34-.45.23-.92.35-1.42.36-1.11-.02-2.19-.51-2.84-1.42-.27-.37-.67-.58-1.17-.58-.5-.02-.94.21-1.21.58-.64.89-1.67 1.42-2.76 1.42h-.14c-1.05 0-2.08-.53-2.72-1.42-.27-.37-.67-.58-1.17-.58-.5-.02-.94.21-1.21.58-.65.92-1.74 1.44-2.83 1.42-.51-.02-.99-.14-1.43-.36-.5-.25-.7-.85-.45-1.34a1 1 0 0 1 1.34-.45c.18.09.38.14.58.14h.03c.44 0 .87-.21 1.13-.58.64-.89 1.67-1.42 2.76-1.42h.14c1.05 0 2.08.53 2.72 1.42.27.36.69.58 1.14.58h.06c.49 0 .92-.21 1.18-.58.64-.89 1.67-1.42 2.76-1.42h.14c1.05 0 2.08.53 2.72 1.42.27.37.66.58 1.17.58.19 0 .39-.05.57-.14"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgPersonSwimming;
